var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eu-flex-item eu-basis_12"},[_c('p',{staticClass:"emd-text _color_subtle _type_caption eu-mb_1"},[_vm._v(" "+_vm._s(_vm.$t('charge.detail.payment-method.boleto.barcode'))+" ")]),_c('p',{staticClass:"emd-card-grid__line"},[_vm._v(_vm._s(_vm.line || '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }